// Source: https://rudrastyh.com/api/instagram-with-pure-javascript.html & https://humaan.com/blog/bigger-square-thumbnails-from-the-instagram-api/
import { formatDistance } from 'date-fns';
import { nl } from 'date-fns/esm/locale';
import modals from 'modals';

function getJSON(url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.onload = function (e) {
        if (xhr.readyState === 4) {
            if (xhr.status === 200) {
                var res = xhr.responseText;
                callback(JSON.parse(res));
            } else { 
                console.error(xhr.statusText);
            }
        }
    }; 

    xhr.onerror = function (e) {
      console.error(xhr.statusText);
    }; 

    xhr.send(null);
}


modals.init();
let token = 'IGQVJVcW9TS3AxSVl3QzVUWFZA0MmhmaVYzTl96ZAEVOc05nbFJ3TUR0d0lNVG03ZAnlJUm5qaV9tVlZA4QmFVc0h4NjdBcHdXY3VkU0lJX3c0emJXRUEzWXBVa0RSeGdNUHctRUtnUGk2MHJGeDVmQ2ZApSQZDZD',
    container = document.querySelector('.js-insta'),
    scrElement = document.createElement('script');

    let numPhotos = 6;

window.processResult = function (data) {

        var options = {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        }


    for (let i = 0; i < numPhotos; i++) {

        let x = i;

        // set variables
        let d = new Date(data.data[x].timestamp),
            src = data.data[x].media_url,
            date = new Date(d).toLocaleString('en-GB', options),
            fullCaption = data.data[x].caption,
            caption = '';
        
        if (fullCaption) { caption = fullCaption.substring(0, 320) + '...' };

        let id = data.data[x].id;
        let link = data.data[x].permalink;
        // set HTML
        container.innerHTML += `
            <li class="instagram__item">
                <a data-modal="#insta_${id}" href="">
                    <img class="instagram__img" src="${src}">
                </a>
                <div class="instagram__info modal" data-modal-window id="insta_${id}">
                    <div class="modal__img">
                        <img src="${src}">
                    </div>
                    <div class="modal__content">
                        <a class="close" data-modal-close href="#">
                            <svg viewbox="0 0 40 40"><path class="close-x" d="M 10,10 L 30,30 M 30,10 L 10,30" /></svg>
                        </a>
                        <p class="instagram__text">
                            ${caption} 
                            <a href="${link}" target="_blank" rel="noopener">Bekijk de post →</a>
                        </p>
                        <p class="instagram__date">${date}</p>
                    </div>
                </div>
            </li>`
            ;
    }
};

if (container) {
  getJSON('/instafeed', function(data) {processResult(data) });
}



// WEBPACK FOOTER //
// ./js/modules/instagram.js